import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';

export const ifaSearchProductsFeatureKey = 'ifaSearchProducts';

export interface IfaSearchProductsState {
  loadIFASearchProducts: any;
  loadIFASearchProductsResponse: any;
  loadIFASearchProductsFailure: any;
}

export const initialState: IfaSearchProductsState = {
  loadIFASearchProducts: undefined,
  loadIFASearchProductsResponse: undefined,
  loadIFASearchProductsFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(actions.loadIfaSearchProducts, (state, action) => ({
    ...state,
    loadIFASearchProducts: action.request
  })),
  on(actions.loadIfaSearchProductsSuccess, (state, action) => ({
    ...state,
    loadIFASearchProducts: action.response
  })),
  on(actions.loadIfaSearchProductsFailure, (state, action) => ({
    ...state,
    loadIFASearchProducts: action.error
  }))
);

export const getIFASearchProducts = (state: IfaSearchProductsState) => state.loadIFASearchProductsResponse;
